/**
 * MemberSelect — "Pertenece a / Miembro responsable" (V1.45)
 * Selector de miembros de la unidad familiar + opción "Común (familiar)".
 */
import { useEffect, useRef, useState } from "react";
import { User } from "lucide-react";
import api from "../lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";

let _famPromise = null;
let _mePromise = null;

export function fetchFamilyMembers(force = false) {
  if (force || !_famPromise) _famPromise = api.get("/family").then((r) => r.data.members || []);
  return _famPromise;
}

export function invalidateMembersCache() { _famPromise = null; }

function fetchMe() {
  if (!_mePromise) _mePromise = api.get("/auth/me").then((r) => r.data);
  return _mePromise;
}

export function useFamilyMembers() {
  const [members, setMembers] = useState([]);
  useEffect(() => { fetchFamilyMembers().then(setMembers).catch(() => {}); }, []);
  return members;
}

export function MemberBadge({ memberId }) {
  const members = useFamilyMembers();
  if (!memberId) return null;
  const m = members.find((x) => x.id === memberId);
  if (!m) return null;
  return (
    <span className="text-[10px] font-bold uppercase tracking-wider bg-sky-100 text-sky-800 dark:bg-sky-950/50 dark:text-sky-300 px-1.5 py-0.5 rounded inline-flex items-center gap-1" data-testid={`member-badge-${memberId}`}>
      <User size={10} /> {m.name}
    </span>
  );
}

export default function MemberSelect({ value, onChange, testId = "member-select", preselectCurrent = false }) {
  const members = useFamilyMembers();
  const done = useRef(false);
  useEffect(() => {
    if (!preselectCurrent || done.current || value) return;
    (async () => {
      try {
        const me = await fetchMe();
        const mine = (await fetchFamilyMembers()).find((m) => m.user_id === me.id);
        if (mine && !done.current) { done.current = true; onChange(mine.id); }
      } catch { /* noop */ }
    })();
  }, [preselectCurrent, members.length]);
  return (
    <Select value={value || "__comun__"} onValueChange={(v) => { done.current = true; onChange(v === "__comun__" ? null : v); }}>
      <SelectTrigger data-testid={testId}><SelectValue placeholder="Común (familiar)" /></SelectTrigger>
      <SelectContent>
        <SelectItem value="__comun__">Común (familiar)</SelectItem>
        {members.map((m) => <SelectItem key={m.id} value={m.id}>{m.name}</SelectItem>)}
      </SelectContent>
    </Select>
  );
}
